import $http from './index'
import { getFullDate, storage } from '../tools'
import {
  OSS_ACCESS_KEY_ID,
  UPLOAD_SIGN,
  UPLOAD_POLICY,
  UPLOAD_EXPIRE,
  UPLOAD_PERMISS_URL,
  OSS_UPLOAD_HOST,
  TUploadCategory
} from '@/constants'

// 验证授权是否过期
export function verifyUploadPermiss(): Promise<boolean> {
  return new Promise((resolve, reject) => {
    $http
      .get(UPLOAD_PERMISS_URL)
      .then(
        (res: IAnyObject) => {
          const { policy, signature, expireEndTime, host, accessKeyId } = res
          storage.set(UPLOAD_POLICY, policy)
          storage.set(UPLOAD_SIGN, signature)
          storage.set(UPLOAD_EXPIRE, expireEndTime)
          // oss host和accessKeyId由后端提供
          storage.set(OSS_UPLOAD_HOST, host)
          storage.set(OSS_ACCESS_KEY_ID, accessKeyId)
          resolve(true)
        },
        err => {
          reject(false)
        }
      )
      .finally(() => {
        //
      })
  })
}

function getExtName(type = 'image/png') {
  const arr = type.split('/')
  return arr[1]
}

//设置上传到oss中的文件名
export function setOSSUploadFileName(
  file: File | Blob,
  category: TUploadCategory
) {
  let key = '', //存储到oss中的文件名
    picExtName = getExtName(file.type), // 获取文件后缀
    timeStamp = Date.now(), //获取13位时间戳
    randomSix = Math.random()
      .toString()
      .slice(-6) //获取6位随机数

  switch (category) {
    case 'id-front' :
    case 'id-back' : //身份证
      key =
        `id/${getFullDate()}/${category}-` +
        timeStamp +
        '-' +
        randomSix +
        '.' +
        picExtName
      break
    case 'voucher' : //订单发票
    case 'license' : //营业执照
    case 'remittance' : //还款凭证
    case 'face' : //人脸识别
    case 'contract' : //合同
    case 'empProof' : //邀请员工的员工证明文件
      key =
        `${category}/${getFullDate()}/${category}-` +
        timeStamp +
        '-' +
        randomSix +
        '.' +
        picExtName
      break
    default :
      break
  }
  return key
}

// 设置上传数据
export async function setUploadData(
  file: File | Blob,
  category: TUploadCategory
): Promise<[FormData, string]> {
  const expireTime = Number(storage.get(UPLOAD_EXPIRE)) || 0
  if (Date.now() > expireTime) {
    // 如果过期要重新获取一次
    const r = await verifyUploadPermiss()
  }
  const key = setOSSUploadFileName(file, category) // 设置文件名
  const fd = new FormData()
  fd.append('key', key)
  fd.append('policy', storage.get(UPLOAD_POLICY))
  fd.append('OSSAccessKeyId', storage.get(OSS_ACCESS_KEY_ID))
  fd.append('success_action_status', '200')
  fd.append('signature', storage.get(UPLOAD_SIGN))
  fd.append('file', file)
  return [fd, key]
}
